import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "align" }
const _hoisted_2 = { class: "align" }
const _hoisted_3 = { class: "wrap" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "align" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { key: 4 }
const _hoisted_23 = { key: 5 }
const _hoisted_24 = { key: 6 }
const _hoisted_25 = { key: 7 }
const _hoisted_26 = { key: 8 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[15] || (_cache[15] = _createElementVNode("h3", null, "Basic infos", -1)),
    (_ctx.zipFile)
      ? (_openBlock(), _createElementBlock("div", _normalizeProps(_mergeProps({ key: 0 }, _ctx.$attrs)), [
          _createElementVNode("ul", _hoisted_1, [
            _createElementVNode("li", null, [
              _cache[0] || (_cache[0] = _createElementVNode("strong", null, " File name ", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.zipFile.getFileName()), 1)
            ]),
            _createElementVNode("li", null, [
              _cache[1] || (_cache[1] = _createElementVNode("strong", null, " File size ", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.zipFile.getFileSize()) + " Bytes", 1)
            ])
          ])
        ], 16))
      : _createCommentVNode("", true),
    (_ctx.payload && _ctx.payload.metadata)
      ? (_openBlock(), _createElementBlock("div", _normalizeProps(_mergeProps({ key: 1 }, _ctx.$attrs)), [
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otaMetadata, (formatter) => {
              return (_openBlock(), _createElementBlock("li", {
                key: formatter.name
              }, [
                _createElementVNode("strong", null, _toDisplayString(formatter.name.trim() + ' '), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(String(_ctx.payload[formatter.key]).trim()), 1)
              ]))
            }), 128))
          ])
        ], 16))
      : _createCommentVNode("", true),
    (_ctx.payload && _ctx.payload.manifest)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _cache[2] || (_cache[2] = _createElementVNode("strong", null, " Incremental ", -1)),
              (_ctx.payload.preBuild)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, " ✅ "))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, " ❌ "))
            ]),
            _createElementVNode("li", null, [
              _cache[3] || (_cache[3] = _createElementVNode("strong", null, " Partial ", -1)),
              (_ctx.payload.manifest.partialUpdate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, " ✅ "))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, " ❌ "))
            ]),
            _createElementVNode("li", null, [
              _cache[4] || (_cache[4] = _createElementVNode("strong", null, " A/B update ", -1)),
              (!_ctx.payload.manifest.nonAB)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, " ✅ "))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, " ❌ "))
            ]),
            (_ctx.payload.manifest.dynamicPartitionMetadata)
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                  _cache[5] || (_cache[5] = _createElementVNode("strong", null, " VAB ", -1)),
                  (_ctx.payload.manifest.dynamicPartitionMetadata.snapshotEnabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, " ✅ "))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, " ❌ "))
                ]))
              : _createCommentVNode("", true),
            (_ctx.payload.manifest.dynamicPartitionMetadata)
              ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                  _cache[6] || (_cache[6] = _createElementVNode("strong", null, " VABC ", -1)),
                  (_ctx.payload.manifest.dynamicPartitionMetadata.vabcEnabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, " ✅ "))
                    : (_openBlock(), _createElementBlock("span", _hoisted_17, " ❌ "))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _cache[7] || (_cache[7] = _createElementVNode("strong", null, " Wipes Data ", -1)),
              (_ctx.isDataWipePackage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, " ✅ "))
                : (_openBlock(), _createElementBlock("span", _hoisted_19, " ❌ "))
            ]),
            (_ctx.totalDynamicPartitionSize)
              ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                  _cache[8] || (_cache[8] = _createElementVNode("strong", null, " Total Dynamic Partition Size ", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.totalDynamicPartitionSize), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.totalCOWSize)
              ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                  _cache[9] || (_cache[9] = _createElementVNode("strong", null, " Total VABC COW Size ", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.totalCOWSize), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.totalDataSize)
              ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                  _cache[10] || (_cache[10] = _createElementVNode("strong", null, " Total Data Size ", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.totalDataSize) + " Bytes ", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.vabcCompressionParam)
              ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                  _cache[11] || (_cache[11] = _createElementVNode("strong", null, " VABC Compression Algorithm ", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.vabcCompressionParam), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.compressionFactor)
              ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                  _cache[12] || (_cache[12] = _createElementVNode("strong", null, " Compression Factor ", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.compressionFactor), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.cowVersion)
              ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                  _cache[13] || (_cache[13] = _createElementVNode("strong", null, " Cow Version ", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.cowVersion), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.securityPatchLevel)
              ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                  _cache[14] || (_cache[14] = _createElementVNode("strong", null, " Security Patch Level ", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.securityPatchLevel), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}